import { FaxDenialReason } from "../../../api/postCall/faxLetter";

/** Dropdown wording follows the clinical review specification; values are stable API codes. */
export const DENIAL_REASON_OPTIONS = [
  {
    value: FaxDenialReason.StepTherapy,
    label: "Non-preferred drug / step therapy",
  },
  {
    value: FaxDenialReason.Indication,
    label: "Indication not supported by NCCN/FDA",
  },
  {
    value: FaxDenialReason.ClinicalCriteria,
    label: "Clinical / lab criterion not met",
  },
  {
    value: FaxDenialReason.Continuation,
    label: "Continuation / re-authorization criteria not met",
  },
  {
    value: FaxDenialReason.PolicyLimit,
    label: "Dose / quantity / frequency / duration exceeds policy",
  },
  {
    value: FaxDenialReason.Documentation,
    label: "Documentation not provided / insufficient",
  },
  {
    value: FaxDenialReason.Coverage,
    label: "Coverage / benefit exclusion (non-covered)",
  },
  {
    value: FaxDenialReason.Provider,
    label:
      "Provider / site / network issue (incl. site-of-care / home infusion)",
  },
  { value: FaxDenialReason.Other, label: "Other (specify)" },
];
